import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { delData } from '../../Redux/Actions/modelsDataActions';
import axios from 'axios';
import { toast } from 'react-toastify';

const Trash = props => {
  const delClicked = id => {
    const { model } = props;
    if (window.confirm('Êtes-vous certain?')) {
      axios
        .delete(`api/v1/${model}/${id}`)
        .then(() => {
          props.onDelData(id);
        })
        .catch(e => {
          toast.error(`Impossible de supprimer l'item`);
        });
    }
  };
  return (
    <FontAwesomeIcon
      icon={faTrashAlt}
      onClick={() => delClicked(props.row.original.id)}
    />
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDelData: id => dispatch(delData(id, ownProps.model)),
});

export default connect(
  null,
  mapDispatchToProps,
)(Trash);
